import { Col, Container, Row, Image} from "react-bootstrap";
import { FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
import { AiOutlineMail} from "react-icons/ai";
import logo from "../data/logo.jpg";
import { Email } from "./Email";

function Footer() {
    const fixed_logo = {
        width: "125px",
        height: "100px",
        margin: "0 auto",
    };
    return <div style={{backgroundColor: "black"}}> 
        <Container style={{height: "calc(110px + 15vh)"}} fluid>
            <br/>
            <Row><Image src={logo} style={fixed_logo} roundedCircle></Image></Row>
            <br/>
            <Row>
                <Col align="center" style={{paddingLeft: "5vw"}}><a href="https://www.facebook.com/mcgill.mtsa"><FaFacebookSquare color="#6bbcff" size="5vh"/></a></Col>
                <Col align="center"><a href="https://www.instagram.com/mtsalovesyou/"><FaInstagramSquare size="5vh" color="#E1306C"/></a></Col>
                <Col align="center" style={{paddingRight: "5vw"}}><a href="mailto:mtsa.team@gmail.com"><AiOutlineMail size="5vh" color="#6bbcff" /></a></Col>
            </Row>
        </Container>
        <Email/>
        <br/>
    </div>;
}

export default Footer;